module.exports = __webpack_public_path__ + "static/media/contactProLogo_Mobile.013e32b9.png";